import { PencilIcon, PlusIcon } from "@heroicons/react/24/outline";

export function SelectIcon({ isSelect }: { isSelect: boolean }) {
  return isSelect ? (
    <PencilIcon width={24} height={24} color="#9CA3AF" />
  ) : (
    <PlusIcon width={24} height={24} color="#9CA3AF" />
  );
}
